import { useCallback, useState } from "react";
import { useDefinition } from "../../../../hooks/useDefinition";
import { useMessage } from "../../../../hooks/useMessage";

function getUsedColorBackgrounds(container: eXpress.core.IContainer | null | undefined) {
	return container
		? container.spreads
				.flatMap((spread) => spread.pageZones)
				.filter((page) => page.background instanceof eXpress.core.ColorBackground)
				.map((page) =>
					eXpress.HexColorString.fromString(
						(page.background as eXpress.core.ColorBackground).color.webColor,
					),
				)
		: [];
}

function getAllColorBackgrounds(definition: eXpress.core.IDefinition | null) {
	return [
		...getUsedColorBackgrounds(definition),
		...getUsedColorBackgrounds(definition?.configuration),
	].distinct();
}

/** The combination of the used background colors in definition and configuration */
// Remark: shouldn't we separate this? Configuration backgrounds only update when productCode/design changes.
export function useUsedBackgrounds() {
	const definition = useDefinition();
	const [usedColors, setUsedColors] = useState(getAllColorBackgrounds(definition));

	useMessage(
		useCallback(
			(message) => {
				if (
					eXpress.core.affectsAssets(message) &&
					message.affectedAssets.backgrounds.length > 0
				) {
					const newBackgroundColors = getAllColorBackgrounds(definition);
					// Prevent rerender if array contains the same values
					if (!eXpress.collections.arrays.equals(usedColors, newBackgroundColors)) {
						setUsedColors(newBackgroundColors);
					}
				}
			},
			[definition, usedColors],
		),
	);

	return {
		usedColors,
	};
}
